export enum Provider {
  Arag = 1,
  ArcLegal = 2,
  FinancialLegalInsurance = 3,
  Strategic = 4,
  LegalProtectionGroup = 5
}
